/**
 *
 * Header
 *
 */

import React from "react";
import styled from "styled-components";
import { Button, Container, useTheme, useMediaQuery } from "@mui/material";
import logoSixprotocol from "../../../assets/images/logo-sixprotocol.png";
import logoSixzone from "../../../assets/images/logo-sixzone.png";

const HeaderStyle = styled.header`
  flex-shrink: 0;
  z-index: 10;
  top: 0;
  width: 100%;
  background: #000;
  padding: 10px 0px;

  > div {
    height: 100%;
  }
`;

const Layout = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CustomLogo = styled(Button)({
  "&.MuiButtonBase-root": {
    "&:hover": {
      color: "unset",
      backgroundColor: "unset",
      boxShadow: "none",
    },
  },
});

function Header() {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const sm = useMediaQuery(theme.breakpoints.only("sm"));

  return (
    <HeaderStyle>
      <Container maxWidth="xl">
        <Layout>
          <CustomLogo
            href="/"
            sx={{ py: { md: 1, xs: 0 }, px: 0, justifyContent: "left" }}
          >
            <img
              src={logoSixzone}
              alt="logoSixzone"
              width={md ? "16%" : sm ? "26%" : "34%"}
            />
          </CustomLogo>
          <CustomLogo
            sx={{ py: { md: 1, xs: 0 }, px: 0, justifyContent: "end" }}
          >
            <img
              src={logoSixprotocol}
              alt="logoSixprotocol"
              width={md ? "14%" : sm ? "26%" : "28%"}
            />
          </CustomLogo>
        </Layout>
      </Container>
    </HeaderStyle>
  );
}

export default Header;
